<template>
  <ResultViewType2 model="pp" csv-item-type="Pathway" />
</template>

<script>
import ResultViewType2 from '@/components/ResultViews/ResultViewType2.vue';

export default {
  name: 'PathwayPredictionResultView',
  components: {
    ResultViewType2
  }
};
</script>
